export var MarketingParams;
(function (MarketingParams) {
  MarketingParams["HMC_ACTIVE"] = "hmc_active";
})(MarketingParams || (MarketingParams = {}));
